
const navArray = ({
   navItemsFromRouter = [],
   externalLinks = [],
  }) =>
  {
  /**
   * Generate site map navigation
   */

    const group = navItemsFromRouter.reduce(
      (prev, current) => ({
        ...prev,
        [current.groupId]: [...(prev[current.groupId] || []), current],
      }),
      {}
    );


    const groupArray = Object.values(group);


    let finalItems = groupArray.map((group) => {
      return group.length > 1 ? {
        groupId: group[0].groupId,
        name: group[0].name,
        external: group[0].external,
        path: (typeof group[0].path === 'object') ?  group[0].path[1] : group[0].path,
        subPages: group.map((page) => {
          return {
            name: page.subName,
            path: Array.isArray(page.path) ? page.path[0] : page.path,
          }
        }),
      } : {
        groupId: group[0].groupId,
        name: group[0].name,
        path: Array.isArray(group[0].path) ? group[0].path[0] : group[0].path,
        external: group[0].external,
      };
    })

    // adding external links
    finalItems = [
      ...finalItems,
      ...externalLinks,
    ];
// console.log(finalItems)
    return finalItems;

}
export {navArray};